const config = {
  navTitle: "Super Challenge Rugby | Biarritz Olympique",
  titlePart1: "Super Challenge Rugby",
  titlePart2: "à Biarritz",
  date: "Du 12 au 13 Avril 2025",
  logo: {
    altName: "mycontest.club",
    src: "/logo512.png",
  },
  body: "Bienvenue au Super Challenge Rugby. Ce site web vous accompagnera tout au long de l'événement placé sous le signe du rugby et de l'amitié. Bon tournoi !",
  mainButton: {
    label: "Suivre les résultats",
    link: "/games",
  },
  secondaryButton: {
    label: "Le Super Challenge",
    link: "https://www.superchallengedefrance.com/bienvenue",
  },
  // altLink: {
  //   label: `Retrouver l'édition ${new Date().getFullYear() - 1}`,
  //   link: "https://mycontest.club",
  // },
  altLink: {
    label: null as string | null,
    link: null as string | null,
  },
};

export default config;
